import React from 'react';
import BlockChart from '../../BlockChart';
import { useGetPublisherConsentsQuery } from '../../../api/publisherApiSlice';
import StackedPercentageBarChart from '../../charts/StackedPercentageBarChart'
import consentBarChartTransformer from '../../../services/data/charts/consentBarChartTransformer';

export default function ConsentBarChart ( { source, title, publisherId, startDate, endDate } ) {
  const defaultData = {"categories":["ios","android"],"series":[{"name":"all","data":[0,0]},{"name":"media","data":[0,0]},{"name":"data","data":[0,0]},{"name":"none","data":[0,0]}]}
  const { data = [], isSuccess, isLoading } = useGetPublisherConsentsQuery({publisherId, startDate, endDate})
  const chartData = consentBarChartTransformer(data, source, defaultData)

  return (
    <BlockChart title={title} isSuccess={isSuccess} isLoading={isLoading}>
      <StackedPercentageBarChart data={chartData}/>
    </BlockChart>
  )
}
